import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';
import { ADVERTISE_NAV } from '@/constants/testIds/advertise';

// Horizontal step indicator shared by all three advertise tracks — same
// visual language as AddListingWizard's stepper, generalized for N steps.
export function AdvertiseStepper({ steps, currentIndex }) {
  return (
    <div className="flex items-center justify-between" data-testid={ADVERTISE_NAV.stepper}>
      {steps.map((step, i) => (
        <div key={step.id} className="flex flex-1 items-center last:flex-none">
          <div className={cn('flex items-center gap-2', i <= currentIndex ? 'text-blue-600' : 'text-slate-400')}>
            <span
              className={cn(
                'grid h-8 w-8 shrink-0 place-items-center rounded-full border-2 text-xs font-semibold',
                i < currentIndex ? 'border-blue-600 bg-blue-600 text-white' : i === currentIndex ? 'border-blue-600' : 'border-slate-300'
              )}
            >
              {i < currentIndex ? <Check size={14} /> : i + 1}
            </span>
            <span className="hidden text-xs font-medium sm:block md:text-sm">{step.label}</span>
          </div>
          {i < steps.length - 1 && <span className={cn('mx-2 h-0.5 flex-1', i < currentIndex ? 'bg-blue-600' : 'bg-slate-200')} />}
        </div>
      ))}
    </div>
  );
}
